export enum DateFrequency {
  None,
  Hourly,
  Daily,
  Weekly,
  Monthly,
}
